import {createType, createAction} from 'store/utils';

const prefix = 'HISTORY';

export const UPDATE_HISTORY = createType(prefix, 'UPDATE');
export const updateHistory = (payload: HistoryState): Action =>
  createAction(UPDATE_HISTORY, payload);
